var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.875,
    y: 1.875,
    width: 12.25,
    height: 12.25,
    rx: 6.125,
    stroke: "#B0B2B6",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 4.5l-8.75 7",
    stroke: "#B0B2B6",
    strokeWidth: 1.75
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgLz4KICAgIDxyZWN0IHg9IjEuODc1IiB5PSIxLjg3NSIgd2lkdGg9IjEyLjI1IiBoZWlnaHQ9IjEyLjI1IiByeD0iNi4xMjUiIHN0cm9rZT0iI0IwQjJCNiIgc3Ryb2tlLXdpZHRoPSIxLjc1IiAvPgogICAgPHBhdGggZD0iTTEyLjM3NSA0LjVMMy42MjUgMTEuNSIgc3Ryb2tlPSIjQjBCMkI2IiBzdHJva2Utd2lkdGg9IjEuNzUiIC8+Cjwvc3ZnPgo=";
export { SvgDisabled as ReactComponent };